import React from 'react'
import { Widget, mk_widget, Action, loadingAsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import { Link, withRouter } from 'react-router-dom'
import { Page, TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { Pagination } from './pagination.mod'
import { t } from 'i18next'
import { List } from 'immutable'
import { RouteComponentProps } from 'react-router'
import qs from 'qs'
import { dateToString } from '../../cms/blocks/utils.gen'
import moment from 'moment'
import { map_language } from '../../../utils'

export const postOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'news' | 'story'
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'news' | 'story'
) =>
  mk_widget({
    run: (setState) => {
      const pageHeader = page.blocks.find((block) => block.kind == 'vidda/header')
      page.blocks.splice(page.blocks.indexOf(pageHeader))

      let posts = type == 'news' ? page.extra_data.news : page.extra_data.stories

      return (
        <section className='block block--listing lst'>
          <div className="lst__inner container container--s gutter--m spacing--m">
            {/* <OverviewFilters
              type={posts.kind}
              years={
                posts.kind === 'news' && posts.years.kind == 'loaded'
                  ? posts.years.value
                  : posts.kind === 'story'
                    ? null
                    : null
              }
              categories={posts.categories.kind == 'loaded' ? posts.categories.value : null}
              disabled={posts.async.kind == 'loading'}
              applyFilters={() =>
                setState((s) => {
                  return s.page.kind == 'loaded'
                    ? {
                      ...s,
                      page: {
                        ...s.page,
                        value: {
                          ...s.page.value,
                          extra_data:
                            type == 'news'
                              ? {
                                ...s.page.value.extra_data,
                                news: {
                                  ...s.page.value.extra_data.news,
                                  async: get_posts(null, type),
                                  current_page: null,
                                },
                              }
                              : {
                                ...s.page.value.extra_data,
                                stories: {
                                  ...s.page.value.extra_data.stories,
                                  async: get_posts(null, type),
                                  current_page: null,
                                },
                              },
                        },
                      },
                    }
                    : s
                })
              }
            /> */}
            {posts.async.kind == 'loaded' ? (
              <>
                {posts.async.value.kind == 'news' ? (
                  posts.async.value.posts.map((post) => news_post(post)).length == 0 ? (
                    <div className="text--styled">
                      <p dangerouslySetInnerHTML={{ __html: t('filter.noResults') }} />
                    </div>
                  ) : (
                    <ul className="lst__list">{posts.async.value.posts.map((post) => news_post(post))}</ul>
                  )
                ) : <></>}
                <Pagination
                  pager={{
                    current_page: posts.current_page,
                    items_per_page: 12,
                    total_items: posts.async.value.total_articles,
                    total_pages: posts.async.value.total_pages,
                  }}
                  setPage={(new_page: number) =>
                    setState((s) => {
                      return s.page.kind == 'loaded'
                        ? {
                          ...s,
                          page: {
                            ...s.page,
                            value: {
                              ...s.page.value,
                              extra_data:
                                type == 'news'
                                  ? {
                                    ...s.page.value.extra_data,
                                    news: {
                                      ...s.page.value.extra_data.news,
                                      async: get_posts(new_page, type),
                                      current_page: new_page,
                                    },
                                  }
                                  : {
                                    ...s.page.value.extra_data,
                                    stories: {
                                      ...s.page.value.extra_data.stories,
                                      async: get_posts(new_page, type),
                                      current_page: new_page,
                                    },
                                  },
                            },
                          },
                        }
                        : s
                    })
                  }
                />
              </>
            ) : (<div className="loader">
              <div className="loader__inner"></div>
            </div>
            )}
          </div>
        </section>
      )
    },
  })

function news_post(post: WordPress.NewsArticleResponse) {
  const header = post.custom_blocks.find((block) => block.blockName == 'vidda/header')
  return (
    <li className="lst__item">
      <Link className="lst__link" to={toRelativeUrl(post.link)}>
          <time className="lst__date typo--s" dateTime={post.date}>{moment(post.date).locale(map_language(window.wp.language)).format('D MMMM YYYY')}</time>
          <h3 className="lst__title ff--primary typo--ml">{decodeHTMLEntities(post.title.rendered)}</h3>
          {header && header.blockName == 'vidda/header' && (
            <p className="lst__intro" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
          )}
      </Link>
    </li>
  )
}

function story_post(post: WordPress.StoryResponse) {
  const header = post.custom_blocks.find((block) => block.blockName == 'vidda/header')
  return (
    <li className="grid__item">
      {post.link ? (
        <Link className="grid__link" to={toRelativeUrl(post.link)}>
          <div className="grid__content">
            {header && header.blockName == "vidda/header" ? 
              <>
                <h2 
                  className="grid__title typo--l"
                  dangerouslySetInnerHTML={{__html: decodeHTMLEntities(header.attrs.title ? header.attrs.title : post.title.rendered)}}
                />
                { (post.excerpt || header.attrs.intro) &&
                  <div 
                    className="grid__intro typo--2xs" 
                    dangerouslySetInnerHTML={{__html: post.excerpt && post.excerpt.rendered ? post.excerpt.rendered : header.attrs.intro}} 
                  />
                }
              </> : <>
                <h2 
                  className="grid__title typo--l" 
                  dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(post.title.rendered) }} 
                />
                { post.excerpt && 
                  <div 
                    className="grid__intro typo--2xs" 
                    dangerouslySetInnerHTML={{__html: post.excerpt.rendered}} 
                  />
                }
              </>
            }

            <span className="grid__fauxlink">{t('general.readMore')}</span>
          </div>
          <div className="grid__visual fit-object">
            {post.featured_media_object ? (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            ) : (
              <img className="grid__placeholder" alt="placeholder image" src="/frontend/images/placeholder.jpg" />
            )}
          </div>
        </Link>
      ) : (
        <div className="grid__inner">
          <div className="grid__content">
            <h2 className="grid__title typo--l">{decodeHTMLEntities(post.title.rendered)}</h2>
            {header && header.blockName == 'vidda/header' && (
              <p className="grid__intro typo--2xs" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
            )}
          </div>
          <div className="grid__visual fit-object">
            {post.featured_media_object ? (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            ) : (
              <img className="grid__placeholder" alt="placeholder image" src="/frontend/images/placeholder.jpg" />
            )}
          </div>
        </div>
      )}
    </li>
  )
}

export function get_posts(page, postType: 'news' | 'story') {
  // const { category, year } = window.history.state?.state
  var params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  let category = params.category as any
  let year = params.year as any

  console.log('get posts3')
  console.log(category, year)

  const reqArgs = {
    per_page: 12,
    page: page + 1,
  }
  const categoryFilter =
    postType == 'news'
      ? {
          news_taxonomy: category,
        }
      : postType == 'story'
      ? {
          story_taxonomy: category,
        }
      : {}

  const yearFilter: WordPress.PostRequestArguments =
    postType == 'news' && year
      ? {
          after: new Date(year, 1, 1).toISOString(),
          before: new Date(parseInt(year) + 1, 1, 1).toISOString(),
        }
      : {}

  return loadingAsyncState<WordPress.OverviewResponse>((_) =>
    postType == 'news'
      ? WordPress.api<WordPress.NewsArticleResponse>()
          .select(postType)
          .where({
            ...reqArgs,
            ...categoryFilter,
            ...yearFilter,
          })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: postType,
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
      : WordPress.api<WordPress.StoryResponse>()
          .select(postType)
          .where({
            ...reqArgs,
            ...categoryFilter,
          })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: postType,
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
  )
}

type OverviewFiltersProps = RouteComponentProps & {
  applyFilters: () => void
  disabled: boolean
} & (
    | {
        type: 'news'
        categories?: Array<WordPress.TaxonomyResponse>
        years?: Array<number>
      }
    | {
        type: 'story'
        categories?: Array<WordPress.TaxonomyResponse>
      }
  )

const OverviewFilters = withRouter((props: OverviewFiltersProps) => {
  var params = qs.parse(props.location.search, { ignoreQueryPrefix: true })
  let category = params.category as any
  let year = params.year as any

  return (<div className="lst__filters">
      {props.categories ? (<>
        <label className='sr-text' htmlFor={'category'} aria-hidden={true}>
          {t('filters.category')}
        </label>
        <select
          className="lst__dropdown dropdown typo--s"
          name="category"
          id="category"
          aria-label={t('filters.category')}
          value={category}
          disabled={props.disabled}
          onChange={(e) => {
            props.history.push({
              search: qs.stringify({
                ...params,
                category: e.target.value,
              }),
            })
            props.applyFilters()
          }}
        >
          <option value={''}>{t('filters.all_categories')}</option>
          {props.categories.map((cat: WordPress.TaxonomyResponse) => (
            <option key={`category-${cat.id}`} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </>
      ) : null}
      {props.type == 'news' && props.years ? (<>
        <label className={`dropdown__label sr-text`} htmlFor={'year'} aria-hidden={true}>
          {t('filters.year')}
        </label>
        <select
          className="lst__dropdown dropdown typo--s"
          name="year"
          aria-label={t('filters.year')}
          disabled={props.disabled}
          value={year}
          onChange={(e) => {
            props.history.push({
              search: qs.stringify({
                ...params,
                year: e.target.value,
              }),
            })
            props.applyFilters()
          }}
        >
          <option value={''}>{t('filters.all_years')}</option>
          {props.years.map((year: number) => (
            <option key={`year-${year}`} value={year}>
              {year.toString()}
            </option>
          ))}
        </select>
      </>
      ) : null}
    </div>
  )
})
